import { Component, OnInit, Input } from '@angular/core';


@Component({
	selector: 'app-icon',
	templateUrl: './app-icon.component.html',
	styleUrls: ['./app-icon.component.scss']
})
export class AppIconComponent implements OnInit {

	private readonly FIRST_LETTER_DEFAULT: string = 'A';
	private readonly BASE_ICON_PATH: string = '/assets/images/app-icon';

	@Input()
	nombre: string;
	@Input()
	desc: string;
	@Input()
	color: string;
	@Input()
	sizeInRem: string;
	@Input()
	textSizeInRem: string;

	isIconRegistered: boolean;
	firstLetter: string;

	// El nombre de las aplicaciones que poseen íconos debe coincidir con el nombre abreviado
	// que posee la aplicación en masterfile. A su vez este nombre debe ser el nombre del archivo
	// del ícono.
	// Así si la aplicación es Masterfile, su abreviatura es mf, y el nombre del archivo del
	// ícono es mf.png
	private registeredIcons: string[] = [
		'hce',
		'thot',
		'jira',
		'adt',
		'SalesForce'
	];

	constructor() {
	}

	ngOnInit() {
		this.isIconRegistered = this.registeredIcons.indexOf( this.nombre ) >= 0;
		this.firstLetter = this.desc? this.desc.charAt(0).toUpperCase(): this.FIRST_LETTER_DEFAULT;
	}

	getIconStyle(): Object {
		let props: Object = { width: `${this.sizeInRem}rem`, height: `${this.sizeInRem}rem` };
		let moreProps: Object = this.isIconRegistered?
			{ 'background-image': `url( ${this.BASE_ICON_PATH}/${this.nombre}.png )` }:
			{ 'background-color': this.color, 'font-size': `${this.textSizeInRem}rem` };

		return { ...props, ...moreProps };
	}



}
